<template>
	<div class="input-inner-wrap">
		<div ref="progressbar" v-if="blockRemaining" class="progressbar"></div>
		<div class="input-and-emoji">
			<input type="text" v-model="emitText" />
			<transition name="text-fade">
				<div class="placeholder-text" v-if="!emitText">{{placeholderText}}</div>
			</transition>
			<span class="material-icons emoji-open" @mousedown="openEmojiPicker">sentiment_satisfied_alt</span>
		</div>
		<transition name="emoji-fade">
			<div class="emoji-picker" :class="{'mobile': true}" ref="emoji-picker" v-if="showEmojiPicker">
				<div class="emoji-wrap">
					<div
						class="single-emoji"
						v-for="(emoji, i) in emojiList"
						:key="i"
						@click="addEmojiToText(emoji)"
					>{{emoji}}</div>
				</div>
			</div>
		</transition>
		<div class="send-button" @click="emitSend" :class="{'blocked': block}">
			<img :src="$images.sendIcon" draggable="false" />
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			emoji:
				"😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 🥰 😘 😗 😙 😚 😋 😛 😝 😜 🤪 🤨 🧐 🤓 😎 🤩 🥳 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 🥺 😢 😭 😤 😠 😡 🤬 🤯 😳 🥵 🥶 😱 😨 😰 😥 😓 🤗 🤔 🤭 🤫 🤥 😶 😐 😑 😬 🙄 😯 😦 😧 😮 😲 🥱 😴 🤤 😪 😵 🤐 🥴 🤢 🤮 🤧 😷 🤒 🤕 🤑 🤠 😈 👿 👹 👺 🤡 💩 👻 💀 ☠️ 👽 👾 🤖 🎃 😺 😸 😹 😻 😼 😽 🙀 😿 😾 👋 🤚 🖐 ✋ 🖖 👌 🤏 ✌️ 🤞 🤟 🤘 🤙 👈 👉 👆 🖕 👇 ☝️ 👍 👎 ✊ 👊 🤛 🤜 👏 🙌 👐 🤲 🤝 🙏 ✍️ 💅 🤳 💪 🦾 🦵 🦿 🦶 👂 🦻 👃 🧠 🦷 🦴 👀 👁 👅 👄 💋 🩸 ❤️ 🧡 💛 💚 💙 💜 🖤 🤍 🤎 💔 ❣️ 💕 💞 💓 💗 💖 💘 💝",
			emojiList: [],
			emitText: "",
			emojiPicker: null,
			showEmojiPicker: false,
			blockRemaining: 0,
			reduceInt: null
		};
	},
	computed: {
		placeholderText() {
			if (this.block) {
				let remaining = this.blockRemaining;
				let text = remaining;
				text += remaining === 1 ? " " + this.$t('chat.input.moreSecond') + " " : " " + this.$t('chat.input.moreSeconds') + " ";
				return this.$t('chat.input.pleaseWait') + " " + text + this.$t('chat.input.toSendMoreMessages');
			} else return this.$t('chat.input.writeYourMessage');
		}
	},
	props: {
		block: Number
	},
	mounted() {
		this.emojiInit();
		this.startEnter();
	},
	beforeDestroy() {
		this.finishProgressbar();
		this.stopEnter();
	},
	watch: {
		block: {
			handler(val) {
				if (val) {
					this.startBlock();
				} else {
					this.stopBlock();
				}
			}
		}
	},
	methods: {
		startBlock() {
			this.blockRemaining = this.block;
			this.stopEnter();
			this.startProgressbar();
		},
		stopBlock() {
			this.finishProgressbar();
			this.startEnter();
		},
		startProgressbar() {
			if (this.reduceInt) {
				clearInterval(this.reduceInt);
				this.reduceInt = null;
			}
			this.reduceInt = setInterval(() => {
				if (!this.blockRemaining) {
					clearInterval(this.reduceInt);
					return;
				}
				this.blockRemaining--;
				this.updateProgress();
			}, 1000);
		},
		finishProgressbar() {
			this.blockRemaining = 0;
			if (this.reduceInt) {
				clearInterval(this.reduceInt);
				this.reduceInt = null;
			}
		},
		updateProgress() {
			let noOfIteration = 100 / this.block;
			let curIteration = this.block - this.blockRemaining;
			let targetStyle = this.$refs["progressbar"].style;
			let newWidthPerc = curIteration * (100 / noOfIteration);
			// max width should be 100% - 90px so in each iteration i reduce a portion of those 90px
			let newWidthDeduction = (90 / noOfIteration) * curIteration;

			targetStyle.width = `calc(${newWidthPerc}% - ${newWidthDeduction}px)`;
		},
		startEnter() {
			setTimeout(() => {
				document.addEventListener("keypress", this.logKey);
			}, 0);
		},
		stopEnter() {
			document.removeEventListener("keypress", this.logKey);
		},
		logKey(e) {
			this.checkIfEnter(e, this.emitSend);
		},
		async checkIfEnter(e, callback) {
			if (this.loadingBool) {
				return;
			}
			if (e.key == "Enter") {
				e.preventDefault();
				await callback();
				try {
					window.Keyboard.hide();
				} catch (error) {
					console.warn("Not a mobile device, unable hide keyboard");
				}
			}
		},
		filterText() {
			let text = this.emitText;
			let lastChar = text[text.length - 1];
			switch (lastChar) {
				case " ":
					this.emitText = text.slice(0, text.length - 1);
					break;
				case "\n":
					this.emitText = text.slice(0, text.length - 1);
					break;

				default:
					return;
			}
			this.filterText();
		},
		emitSend() {
			this.filterText();
			if (this.block || !this.emitText) {
				return;
			}
			// emits text thats in the input and resets input
			this.$emit("send", this.emitText);
			this.emitText = "";
			this.showEmojiPicker = false;
		},
		emojiInit() {
			let emojiss = this.emoji.split(" ");
			this.emojiList = emojiss;
		},
		openEmojiPicker() {
			this.showEmojiPicker = !this.showEmojiPicker;
			if (!this.showEmojiPicker) return;
			this.emojiPicker = this.$refs["emoji-picker"];
			setTimeout(() => {
				document.addEventListener("mousedown", this.checkToCloseEmoji);
			}, 0);
			// can be added logic to position it a bit better but not as important for now
		},
		checkToCloseEmoji(e) {
			for (let i = 0; i < e.target.classList.length; i++) {
				const cls = e.target.classList[i];
				if (cls === "emoji-picker") return;
				if (cls === "emoji-wrap") return;
				if (cls === "single-emoji") return;
			}
			// remove global event listener upon releasing mouse left click
			this.showEmojiPicker = false;
			document.removeEventListener("mousedown", this.checkToCloseEmoji);
		},
		addEmojiToText(emoji) {
			this.emitText += emoji;
		}
	}
};
</script>

<style lang="scss" scoped>
@mixin flex-end {
	display: flex;
	justify-content: flex-end;
	align-items: center;
}
@mixin flex-start {
	display: flex;
	justify-content: flex-start;
	align-items: center;
}
@mixin flex-between {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
@mixin flex-center {
	display: flex;
	justify-content: center;
	align-items: center;
}
@mixin flex-evenly {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
}

.emoji-picker {
	z-index: 42;
	background: white;
	box-shadow: 0px 0px 15px 10px rgba(0, 0, 0, 0.214);
	border-radius: 10px 10px 10px 10px;
	position: absolute;
	width: 130px;
	height: 130px;
	padding: 10px;
	bottom: 60px;
	right: 10px;
	.emoji-wrap {
		width: 100%;
		height: 100%;
		@include flex-center();
		flex-wrap: wrap;
		overflow-y: auto;
		.single-emoji {
			@include flex-center();
			width: 25px;
			height: 25px;
		}
	}
}
.input-inner-wrap {
	position: relative;
	width: 100%;
	height: 100%;
	@include flex-evenly();
	.progressbar {
		transition: all linear 1s;
		z-index: 2;
		bottom: 16px;
		left: 22px;
		position: absolute;
		height: 2px;
		width: 0;
		background: #2e66ff;
	}
}
.emoji-picker.mobile {
}
.input-and-emoji {
	position: relative;
	@include flex-center();
	border-radius: 30px;
	background-color: #ececec;
	height: 35px;
	width: calc(100% - 60px);
	input {
		height: 24px;
		line-height: 24px;
		max-height: calc(3 * 24px);
		max-width: calc(100% - 35px);
		overflow-wrap: break-word;
		padding: 20px;
		box-shadow: none;
		width: calc(100% - 35px);
		border: none;
		background-color: transparent;
	}
	input:focus {
		line-height: 24px;
		outline: none;
	}
	.placeholder-text {
		pointer-events: none;
		position: absolute;
		color: rgba(0, 0, 0, 0.4);
		font-size: 12px;
		left: 20px;
	}
	span {
		cursor: pointer;
		text-align: left;
		width: 35px;
	}
}
.send-button {
	@include flex-center();
	width: 35px;
	height: 35px;
	cursor: pointer;
	background-color: #2e66ff;
	border-radius: 50%;
	&.blocked {
		// pointer-events: none;
		cursor: wait;
		opacity: 0.5;
	}
	img {
		transform: translateX(-2px);
	}
}
</style>